import {FC} from 'react';

import useIsMobile from '@/src/hooks/useIsMobile';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {ProgressLine, Text} from '@/src/ui';

import css from '../styles/SignupProgress.module.css';

const TOTAL_STEPS = 2;

interface SignupProgressProps {
  step?: 1 | 2;
}

const getProgress = (step: 1 | 2): string => {
  switch (step) {
    case 1:
      return ProgressLine.PROGRESS.TWO_QUARTERS;
    case 2:
      return ProgressLine.PROGRESS.FULL;
  }
};

const SignupProgress: FC<SignupProgressProps> = ({step}) => {
  const progress = getProgress(step);
  const {isMaxWidth600} = useIsMobile();

  return (
    <div className={css.main}>
      <div className={css.trialInfo}>
        <Text
          fontWeight={Text.FONT_WEIGHT.BOLD}
          fontSize={
            isMaxWidth600 ? Text.FONT_SIZE.SIZE_18 : Text.FONT_SIZE.SIZE_24
          }
        >
          <TextLocal id={'sing-up-benefits.start-90-days-trial'} />
        </Text>
      </div>
      {step && (
        <>
          <div className={css.progressLine}>
            <ProgressLine progress={progress}></ProgressLine>
          </div>
          <Text color={Text.COLOR.GREY} fontSize={Text.FONT_SIZE.SIZE_12}>
            <TextLocal
              id={'sing-up-benefits.step-of-step'}
              params={{
                step,
                steps: TOTAL_STEPS,
              }}
            />
          </Text>
        </>
      )}
    </div>
  );
};

export default SignupProgress;
